/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListAnnouncementInboxItem } from '../../models/api-response-list-announcement-inbox-item';

export interface Inbox$Params {
}

export function inbox(http: HttpClient, rootUrl: string, params?: Inbox$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAnnouncementInboxItem>> {
  const rb = new RequestBuilder(rootUrl, inbox.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListAnnouncementInboxItem>;
    })
  );
}

inbox.PATH = '/v1/api/announcement-client/inbox';
